import { RouteObject } from 'react-router-dom';

import { CustomizeActivity } from './CustomizeActivity/CustomizeActivity';
import * as Layout from './Layout';



export const root: RouteObject = {

  path: 'customize',
  element: (
    <Layout.FC />
  ),
  children: [{
    path: '',
    index: true,
    element: (
      <CustomizeActivity />
    )
  }]

};
